<template>
    <div class="wrap">
        <div class="info">
            <div class="userName"><b style="font-size:16px">账号：</b>{{loginName}}</div>
            <div
                class="accountBg"
                :style="{ backgroundImage: 'url(' + userAccountBg + ')' }"
            >
                <!-- <van-row
                    type="flex"
                    justify="space-between"
                    class="accountInfo"
                >
                    <van-col span="12">
                        <div class="accountTitle">当前可用时间戳（个）：</div>
                        <div class="accountNum">
                            <p>100</p>
                        </div>
                    </van-col>
                    <van-col span="12" class="accountRight">
                        <span>充值</span>
                    </van-col>
                </van-row> -->
                <van-row
                    type="flex"
                    justify="space-between"
                    class="accountInfo"
                >
                    <van-col span="12" v-if="userInfo.userType=='AUTHORIZATION_ACCOUNT'">
                        <div class="accountTitle" >主账号可用时间戳（个）：</div>
                        <div class="accountNum">
                            <p>{{ balance.tsCount }}</p>
                            <span>个</span>
                        </div>
                    </van-col>
                    <van-col span="12" v-else>
                        <div class="accountTitle" >当前可用时间戳（个）：</div>
                        <div class="accountNum">
                            <p>{{ balance.tsCount }}</p>
                            <span>个</span>
                        </div>
                    </van-col>
                    <van-col span="12" v-if="userInfo.userType=='AUTHORIZATION_ACCOUNT'&& balance.consumeLimitTsCount!==-1">
                        <div class="accountTitle">当前已用时间戳（个）：</div>
                        <div class="accountNum">
                            <p>{{ balance.currentConsumeTsCount }}</p>
                            <span>个</span>
                        </div>
                        <div class="accountBot">
                            当前最大使用限制数：{{ balance.consumeLimitTsCount }}个
                        </div>
                    </van-col>
                    <van-col span="12" class="accountRight" v-if="userInfo.userType=='ADMIN_ACCOUNT'">
                        <span @click="gobuy">充值</span>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="navList">
            <van-cell title="个人资料" is-link @click="openUrl(`/?clientId=952310&partnerType=${$getlocalStorage('partnerType')? $getlocalStorage('partnerType'):0}`)">
                <template #icon>
                    <van-icon class-prefix="vant-ali-shenfenzheng" class="icon icon1" />
                </template>
            </van-cell>
            <van-cell title="我的钱包" is-link  @click="openUrl(`/userAccount/overview?clientId=952310&partnerType=${$getlocalStorage('partnerType')? $getlocalStorage('partnerType'):0}`)">
                <template #icon>
                    <van-icon class-prefix="vant-ali-qianbao" class="icon icon2" />
                </template>
            </van-cell>
            <van-cell title="常见问题" is-link @click="openTsa(`/baike.html?sourceType=952310&access_token=${access_token}`)">
                <template #icon>
                    <van-icon class-prefix="vant-ali-changjianwenti" class="icon icon3" />
                </template>
            </van-cell>
            <van-cell title="修改密码" is-link @click="openUrl(`/userCenter/security?clientId=952310&partnerType=${$getlocalStorage('partnerType')? $getlocalStorage('partnerType'):0}`)">
                <template #icon>
                    <van-icon class-prefix="vant-ali-dangjian_xiugaimima" class="icon icon4" />
                </template>
            </van-cell>
        </div>
        <div class="quit">
            <span @click="logout">退出登录</span>
        </div>
    </div>
</template>

<script>
import {findBalance,logout} from "@/api/service";
export default {
    data() {
        return {
            userAccountBg: require("@/assets/img/userAccountBg.png"),
        };
    },

    components: {},

    computed: {
        balance() {
            return this.$store.state.balance.balance;
        },
        userInfo(){
            return this.$store.state.userInfo.userInfo;
        },
        loginName(){
            return this.$store.state.userInfo.me.loginName;
        },
        access_token(){
            return this.$store.state.userInfo.me.accessToken
        }
    },

    async created() {
        let balance = await findBalance(0);
        console.log(balance);
        this.$store.commit('balance/setBalance', balance);
    },

    methods: {
        gobuy() {
            let userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('micromessenger') !== -1) {//当前页面在微信中打开
                let callBackUrl=encodeURIComponent(window.location.href);
                let path= `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
                window.location.href=process.env.VUE_APP_ACCOUNTUI+path+'&callBackUrl='+callBackUrl
            }else{
                let path= `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
                this.$router.push({
                    path:'/mine/Account?',
                    query:{
                        url:encodeURIComponent(process.env.VUE_APP_ACCOUNTUI+path)
                    }
                })
            }
            
            //window.open(process.env.VUE_APP_ACCOUNTUI+path)
            // this.$dialog.alert({
            //     title: '提示',
            //     message: '我已充值完成，更新可使用服务数',
            //     confirmButtonColor:"#008AFF",
            // }).then(async () => {
            //     let balance = await findBalance(0);
            //     this.$store.commit('balance/setBalance', balance);
            // });
        },
        openUrl(path){
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:encodeURIComponent(process.env.VUE_APP_ACCOUNTUI+path)
                }
            })
            // window.open(process.env.VUE_APP_ACCOUNTUI+path,'_blank')
        },
        openTsa(path){
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:encodeURIComponent(process.env.VUE_APP_TSA+path)
                }
            })
            //window.open(process.env.VUE_APP_TSA+path,'_blank')
        },
        logout(){
            if(this.$getlocalStorage('partnerType')==1){
                logout().then(()=>{
                    localStorage.removeItem('partnerType');
                    localStorage.removeItem('popups');
                    window.location.href = process.env.VUE_APP_CAPITAL;
                }).catch((err)=>{
                    console.log(err)
                })
            }else{
                localStorage.removeItem('partnerType')
                localStorage.removeItem('popups');
                if (process.env.NODE_ENV === 'development') {
                    window.location.href = '/api/api/logout'
                } else {
                    window.location.href = '/opus/api/logout'
                }
            }
            
        }
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 100%;
    overflow-y:auto;
}
.info {
    margin: 11px 0 5px;
    box-sizing: border-box;
    width: 100%;
    padding: 12px 15px;
    background: #fff;
    .userName {
        font-size: 14px;
        margin-bottom: 11px;
        color: #999;
        b{
            font-size: 16px;
            color:#333;
        }
    }
    .accountBg {
        width: 100%;
        height: 102px;
        font-size: 12px;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 2px;
        .accountInfo {
            padding: 17px 10px 0 26px;
        }
        .accountTitle {
            font-size: 12px;
            font-weight: bold;
            color: #ffffff;
        }
        .accountNum {
            font-weight: bold;
            color: #ffec16;
            line-height: 13px;
            margin: 18px 0 0 0;
            p {
                font-size: 15px;
                display: inline-block;
            }
            span {
                font-size: 12px;
            }
        }
        .accountRight {
            text-align: right;
            span {
                width: 83px;
                padding: 8px 0px;
                font-size: 13px;
                font-weight: bold;
                color: #3988fe;
                background: #ffffff;
                border-radius: 15px;
                text-align: center;
                float: right;
                margin-top: 12px;
                display: block;
            }
        }
        .accountBot {
            font-size: 12px;
            font-weight: bold;
            color: #bad1ff;
            line-height: 12px;
            margin-top: 15px;
            display: inline-block;
        }
    }
}
.navList{
    .icon{
        font-size: 20px;
        margin-right: 20px;
    }
    .icon1{
        color:#9DB3F3
    }
    .icon2{
        color:#F4B650
    }
    .icon3{
        color:#86A1EA
    }
    .icon4{
        color:#A6E1CD
    }
    /deep/ .van-cell{
        padding:20px 15px;
    }
}
.quit{
    border-top: 1px solid #ebedf0;
    background: #fff;
    padding:15px;
    span{
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color:#fff;
      background:#3988fe;
      border-radius: 5px;
      font-size: 14px;
      display: block;
    }
}
</style>
